import { makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import { Carousel } from 'react-responsive-carousel'
import { TESTIMONIAL_DATA } from 'src/utils/constants/common'
import Umbrella from 'src/assets/AddedServices/coversUmbrella.svg'
import policyUmbrella from 'src/assets/AddedServices/policyUmbrella.svg'
import { Grid } from '@mui/material'
import VehicleTestimonial from 'src/components/Individual/AddedServices/VehicleTestimonial'
import EnquireNow from 'src/components/Individual/modals/NewCarEnquireNow'
import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal'
import ExploreMoreArrow from 'src/assets/AddedServices/ExploreArrow.svg'
import { addScroll, removeScroll } from 'src/utils/commonMethods'

const ValueAddedServices = () => {
  const classes = useStyles()
  const [modalOpen, setModalClose] = useState(false)

  const CloseModal = () => {
    setModalClose(false)
  }
  const EnquireModalOpen = () => {
    setModalClose(true)
  }
  useEffect(() => {
    if (modalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [modalOpen])
  return (
    <>
      {modalOpen ? (
        <Modal id='modal' open={modalOpen} onClose={CloseModal}>
          <div className={`${classes.modalRoot} modal-container`}>
            <EnquireNow closefunction={CloseModal} />
          </div>
        </Modal>
      ) : null}
      <div className={classes.rootContainer}>
        <div className={classes.contentContainer}>
          <div className={classes.headerContainer}>
            <span className={classes.planningText}>
              Planning to buy <b>new Car/Bike?</b>
            </span>
            <span className={classes.mandatoryText}>
              It&apos;s <b>not mandate</b> to buy insurance{' '}
              <b>from your dealer.</b>
            </span>
          </div>
          <hr className={classes.separator} />
          <span className={classes.subText}>
            Do you know that Showroom Dealers often loot hefty price on
            Insurance?
          </span>
        </div>
        <div className={classes.testimonialContainer}>
          <Carousel
            infiniteLoop={true}
            showArrows={false}
            showStatus={false}
            showThumbs={false}
            showIndicators={true}
            autoPlay={true}
            stopOnHover={true}
            className={'w-100'}
          >
            {TESTIMONIAL_DATA?.map((testimonialDataItem) => (
              <div
                className={classes.carouselItem}
                key={`testimony_${testimonialDataItem?.id}`}
              >
                <VehicleTestimonial
                  testimonial={testimonialDataItem}
                  enquireModalOpen={EnquireModalOpen}
                />
              </div>
            ))}
          </Carousel>
        </div>

        <div className={classes.exploreMoreArrow}>
          <img
            src={ExploreMoreArrow}
            alt='ExploreMoreArrow'
            className={classes.exploreMoreArrowImage}
          />
        </div>

        <div className={classes.coversContainer}>
          <div className={classes.headingContainer}>
            <div className={classes.hrContainer}>
              <hr className={classes.hr} />
              <hr className={classes.hrLine} />
            </div>
            <div className={classes.coversHeading} id='coversHeading'>
              <span>Essential Riders: Don&apos;t Miss These</span>
            </div>
            <div className={classes.hrContainer}>
              <hr className={classes.hr} />
              <hr className={classes.hrLine} />
            </div>
          </div>
          <div className={classes.coversContent}>
            <img
              src={Umbrella}
              alt='umbrella'
              className={classes.policyUmbrellaLogo}
            />
            <span className={classes.coverSubHeading}>
              A comprehensive policy{' '}
              <span className={classes.covers}>covers</span>
            </span>
          </div>
          <div className={classes.coversSubContent}>
            <span>Car accidents &nbsp;|&nbsp;&nbsp;</span>
            <span> Theft &nbsp;|&nbsp;&nbsp;</span>
            <span>
              {' '}
              Damage from natural disasters or vandalism&nbsp; |&nbsp;&nbsp;
            </span>
            <span> Fire accidents & damage during transportation.</span>
          </div>
        </div>
        <div className={classes.additionallyContainer}>
          <div className={classes.additionallyHeading}>
            <span>Additionally, </span>
          </div>
          <div>
            <img
              src={policyUmbrella}
              alt='policyUmbrella'
              className={classes.additionallyLogo}
            />
          </div>
          <div className={classes.additionallyHeadingText}>
            <span>
              Don&apos;t forget to add these additional riders when purchasing
              car insurance.
            </span>
          </div>
        </div>
        <div>
          <Grid
            container
            spacing={2}
            alignItems={'stretch'}
            justifyContent={'center'}
            padding={'20px 0px'}
          >
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>
                  1.Nil Depreciation (Nil Dip) Cover:{' '}
                </div>
                <div className={classes.coverCardText}>
                  This rider ensures that the insurance company covers the
                  entire cost of repairing or replacing car parts without
                  deducting for depreciation. For instance, if there&apos;s
                  damage to your car&apos;s bumper and it needs replacement, the
                  insurance company will pay the entire cost without considering
                  depreciation.
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>2.Engine Cover: </div>
                <div className={classes.coverCardText}>
                  This covers damages to your car&apos;s engine due to
                  accidents, water ingression, or any other mishaps. For
                  example, if your car&apos;s engine gets damaged due to
                  flooding, this cover will pay for the repairs.
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>
                  3.Consumables Cover:{' '}
                </div>
                <div className={classes.coverCardText}>
                  This covers the cost of consumable items in your car such as
                  nuts, bolts, engine oil, lubricants, etc., that are not
                  covered under a standard policy. For instance, if your car
                  needs engine oil change after an accident, this cover will pay
                  for it.
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>
                  4.Key Protector:{' '}
                </div>
                <div className={classes.coverCardText}>
                  This covers the cost of replacing or repairing the car keys if
                  they are lost, stolen, or damaged. For instance, if you lose
                  your car keys, this cover will assist in getting a new key and
                  programming it, if required.
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>
                  5.Return to Invoice:{' '}
                </div>
                <div className={classes.coverCardText}>
                  This cover ensures that in case of theft or total loss of the
                  car, the insurance company will pay the original invoice price
                  of the car rather than its current market value. For example,
                  if your car gets stolen, this cover will compensate you with
                  the amount you paid when purchasing the car.
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>
                  6.Tyre Protector:{' '}
                </div>
                <div className={classes.coverCardText}>
                  This cover provides protection against damages to your
                  car&apos;s tyres, such as punctures, cuts, or bursts. For
                  instance, if your tyre gets punctured, this cover will assist
                  in getting it repaired or replaced.
                </div>
              </div>
            </Grid>
            <Grid item xs={2} sm={4} md={4}>
              <div className={classes.container}>
                <div className={classes.coverCardHeading}>
                  7.Loss of Personal Belongings:{' '}
                </div>
                <div className={classes.coverCardText}>
                  This cover protects personal items inside the car against
                  theft or loss during an accident. For example, if your laptop
                  or mobile phone gets stolen from the car, this cover will
                  compensate for the loss
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={6}
              md={8}
              paddingLeft={'30px !important'}
              paddingTop={'30px !important'}
            >
              <div className={classes.container}>
                <div className={classes.coverDescription}>
                  These riders can be added to your car insurance policy for
                  additional coverage beyond the standard policy, providing
                  specific protections against various risks and scenarios.
                </div>
                <div className={classes.coverNote}>
                  &quot;Note that the Return to Invoice & Tyre Protector riders
                  are typically offered by insurers for cars aged up to 3 to 4
                  years.&quot;
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
        <div className={classes.disclaimerContainer}>
          <div className={classes.disclaimerHeading}>Disclaimer</div>
          <div className={classes.disclaimerText}>
            Choosing the right add-ons depends on your specific needs, how you
            use your Car, and where you live. It&apos;s important to assess what
            you need and pick add-on covers that boost your Car&apos;s
            protection without greatly raising the cost. Always talk to your
            insurance provider for a better understanding of the add-ons and
            their advantages.
          </div>
          <div className={classes.disclaimerNote}>
            Trovity provides information for knowledge purposes only.
          </div>
        </div>
      </div>
    </>
  )
}

export default ValueAddedServices

const useStyles = makeStyles(() => ({
  rootContainer: {
    background: COLORS.WHITE,
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    gap: '10px',
  },
  bannerText: {
    fontSize: '30px',
    fontWeight: '400 !important',
    color: '#A8224B',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
    padding: '10px 0',
  },
  headerContainer: {
    display: 'flex',
    gap: '5px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  planningText: {
    fontSize: '26px',
    fontWeight: '300 !important',
  },
  mandatoryText: {
    fontSize: '18px',
    fontWeight: '400 !important',
    color: COLORS.DARK_PINK,
  },
  subText: {
    fontSize: '16px',
    fontWeight: '400 !important',
  },
  testimonialContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  dealerPrice: {
    fontSize: '30px',
    fontWeight: '600 !important',
    color: '#38508F',
  },
  trovityPrice: {
    fontSize: '30px',
    fontWeight: '600 !important',
    color: '#D6436F',
  },

  exploreMoreArrow: {
    animationName: '$exploreMoreArrow',
    animationDuration: '2s',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'ease-in-out',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '15px',
  },

  '@keyframes exploreMoreArrow': {
    '0%': { transform: 'translate(0,  0px)' },
    '50%': { transform: 'translate(0, 13px)' },
    '100%': { transform: 'translate(0, -0px)' },
  },

  noteContainer: {
    fontSize: '15px',
    fontWeight: '400 !important',
    color: '#8A8A8A',
    fontStyle: 'italic',
    textAlign: 'center',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  carouselItem: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
  },
  testimonyItemContainer: {
    background: 'linear-gradient(0deg, #FFF3F3, #FFF3F3)',
    border: '1px solid #CB87A1',
    borderRadius: '50px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    marginTop: '15px',
  },
  testimonyHeading: {
    position: 'absolute',
    background: '#CB87A1',
    top: '-15px',
    borderRadius: '25px',
    minHeight: '30px',
    minWidth: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0 10px',
  },
  heading: {
    color: COLORS.WHITE,
    fontSize: '11px',
  },
  detailsContainer: {
    display: 'flex',
    gap: '10px',
    padding: '10px 40px',
    justifyContent: 'center',
    alignItems: 'center',
    '@media (max-width:720px)': {
      padding: '20px',
    },
  },
  avatarContainer: {
    width: '10%',
    minWidth: '50px',
  },
  avatarImage: {
    height: '50px',
    width: '50px',
  },
  testimonyDetailsContainer: {
    display: 'flex',
    gap: '5px',
    width: '90%',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
  },
  customerDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  customerName: {
    fontWeight: '600 !important',
    fontSize: '15px',
  },
  customerOccupation: {
    fontWeight: '300 !important',
    fontSize: '12px',
    color: '#686868',
  },
  vehicleDetails: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  vehicleName: {
    fontWeight: '600 !important',
    fontSize: '15px',
  },
  vehicleType: {
    fontWeight: '300 !important',
    fontSize: '12px',
    color: '#686868',
  },
  imageContainer: {
    marginTop: '10px',
  },
  separator: {
    border: '1px solid #E8E8E8',
    width: '100%',
  },
  testimonialImage: {
    width: '80% !important',
  },
  coversContainer: {
    borderBottom: '1px solid #D8D8D8',
    padding: '10px 0px',
    paddingBottom: '25px',
  },
  coversHeading: {
    fontSize: '20px',
    fontWeight: '400',
    lineHeight: '26px',
    color: '#B92250',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    width: '100%',
    textAlign: 'center',
  },
  coverSubHeading: {
    fontSize: '17px',
    fontWeight: '600',
    lineHeight: '22px',
  },
  covers: {
    color: '#EF669B',
  },
  coversContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',
    padding: '20px',
  },
  coversSubContent: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '19px',
    textAlign: 'center',
  },
  additionallyContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px',
    padding: '10px 100px',
    paddingTop: '20px',
  },
  additionallyHeading: {
    fontSize: '20px',
    fontWeight: '500',
    lineHeight: '26px',
    color: '#EF669B',
    fontStyle: 'ittalic',
  },
  additionallyHeadingText: {
    fontSize: '17px',
    lineHeight: '22px',
    fontWeight: '600',
  },
  hr: {
    border: '1px solid #E1E1E1',
    marginBottom: '2px',
  },
  disclaimerContainer: {
    border: '1px solid #F4F4F4',
    borderRadius: '10px',
    background: '#F4F4F4',
    padding: '20px',
  },
  disclaimerHeading: {
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '15px',
    display: 'flex',
    justifyContent: 'flex-start',
  },
  disclaimerText: {
    fontSize: '11px',
    fontWeight: '400',
    lineHeight: '14px',
  },
  disclaimerNote: {
    fontSize: '12px',
    lineHeight: '15px',
    fontWeight: '500',
    fontStyle: 'italic',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  coverCardHeading: {
    fontSize: '13px',
    fontWeight: '700',
    lineHeight: '17px',
    padding: '10px 0px',
  },
  coverCardText: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '15px',
    border: '1px solid #D3D3D3',
    padding: '10px',
    borderRadius: '10px',
    boxShadow: '5px 5px #D3D3D3',
    height: '100%',
  },
  coverDescription: {
    fontSize: '13px',
    fontWeight: '400',
    lineHeight: '17px',
    borderBottom: '1px solid #D8D8D8',
    padding: '10px 0px',
  },
  coverNote: {
    fontSize: '16px',
    fontStyle: 'italic',
    fontWeight: '500',
    lineHeight: '21px',
    padding: '10px 0px',
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  headingContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hrContainer: {
    width: '70%',
  },
  hrLine: {
    marginTop: '2px',
    border: '1px solid #E1E1E1',
  },
  exploreMoreArrowImage: {
    height: '20px',
    width: '20px',
  },
  modalRoot: {
    background: 'transparent !important',
    width: '60%',
    maxWidth: '970px',
    maxHeight: '90%',
  },
}))
